var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"number-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',{staticClass:"font-bold number-label"},[_vm._v(_vm._s(_vm.content || _vm.defaultIfMissing))])])}
var staticRenderFns = []

export { render, staticRenderFns }